import { alpha, darken, Theme } from '@mui/material';

export const getLinkStyles = (theme: Theme) => ({
  borderBottom: `1px solid ${alpha(theme.palette.link.main, 0.5)}`,
  textDecoration: 'none',
  transition: 'color .3s, border-color .3s',

  '&&': {
    color: theme.palette.primary.main,
  },

  '&:hover': {
    textDecoration: 'none',
    color: darken(theme.palette.primary.main, 0.2),
    borderColor: darken(theme.palette.primary.main, 0.2),
  },
});
